import { render, staticRenderFns } from "./SortingOptions.vue?vue&type=template&id=0ef1fe8c&"
import script from "./SortingOptions.vue?vue&type=script&lang=js&"
export * from "./SortingOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports